import { EmConstrucao } from '../app/EmConstrucao.js';

export function TerritorioTela() {
  return <EmConstrucao titulo="Território" />;
}
